<div *ngIf="this.loader.getLoading()" class="cssload-container">
    <div class="spintarget">
        <mat-spinner color="primary"></mat-spinner>
    </div>
    <div class="message">Submitting your CPD plan to the Law Society</div>
</div>